import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OutcomeConfig } from '@core/models/built/procedure-step-config.model';
import { ProcedureStep } from '@core/models/procedures.model';
import { FlowchartMode } from '@flowchart';
import { TranslocoService } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { getProcedureStepTypeConfigByType } from 'src/app/modules/core/models/procedure-step-config-map';
import { procedureSelectors } from 'src/app/pages/shell/procedures/store/procedure.selectors';

import it from './i18n/outcome-edit.it.json';

@Component({
  templateUrl: './outcome-edit.component.html',
  styles: [],
})
export class OutcomeEditComponent implements OnInit, OnDestroy {
  @Input() step?: ProcedureStep;
  @Input() mode: FlowchartMode = 'edit';
  @Input() editForm!: FormGroup;

  steps$ = this.store.select(procedureSelectors.steps.selectAll).pipe(
    map((steps) =>
      steps.reduce((acc, curr) => {
        const typeConfig = getProcedureStepTypeConfigByType(curr.type);
        if (typeConfig?.checkValueFnOperators && typeConfig.checkValueFnOperators?.length > 0) {
          acc = [...acc, curr];
        }
        return acc;
      }, [] as ProcedureStep[])
    )
  );

  constructor(private fb: FormBuilder, private translocoSvc: TranslocoService, private store: Store) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  ngOnInit() {
    const config = this.step?.config as OutcomeConfig;

    let configGroup = this.editForm.get('config') as FormGroup;
    if (!configGroup) {
      this.editForm.addControl('config', this.fb.group({}));
      configGroup = this.editForm.get('config') as FormGroup;
    }
    configGroup.addControl('result', this.fb.control(config?.result, [Validators.required]));
    configGroup.addControl('progress', this.fb.control(config?.progress || 100, [Validators.required]));
    configGroup.addControl('defaultOutputValue', this.fb.control(config?.defaultOutputValue));
    configGroup.addControl('sourceProcedureStepId', this.fb.control(config?.sourceProcedureStepId));

    if (this.mode === 'view') {
      (this.editForm.get('config') as FormGroup).disable();
    }
  }

  ngOnDestroy() {
    const configGroup = this.editForm.get('config') as FormGroup;
    if (configGroup) {
      configGroup.removeControl('result');
      configGroup.removeControl('progress');
      configGroup.removeControl('defaultOutputValue');
      configGroup.removeControl('sourceProcedureStepId');

      if (Object.keys(configGroup.controls).length <= 0) {
        this.editForm.removeControl('config');
      }
    }
  }
}
